import { render, staticRenderFns } from "./ExceptionSettings.vue?vue&type=template&id=3b492474&scoped=true&"
import script from "./ExceptionSettings.vue?vue&type=script&lang=js&"
export * from "./ExceptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionSettings.vue?vue&type=style&index=0&id=3b492474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b492474",
  null
  
)

export default component.exports